import React, { useEffect, useState } from 'react'
import { useLocation, Navigate, useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner'
import { FormattedMessage } from 'react-intl';

const ConfirmEmail = () => {

  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const token = parameters.get('token');

  const [loading, setLoading] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [isExpired, setIsExpired] = useState(false)

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      setLoading(true)
      const headers = {
        headers: {}
      };
      const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/users/register/checktoken/${token}`, headers)
      data.then(res => {
        setLoading(false)
        if (res['data'].status === "ok") {
          setIsVerified(true)
          setTimeout(() => {
            navigate('/app/login')
          }, 2000);
        } else if (res['data'].status === "ko") {
          setIsExpired(true)
        }
      })
    } catch (error) {
      toast.error(error)
    }
  }, [token]);


  return (
    <div>
      {loading &&
        <div className="col-span-6 flex justify-center items-center mt-36">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#2f4d44"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>}
      {(!loading && isVerified) &&
        <>
          <div className="col-span-6 flex justify-center items-center mt-36">
            <FormattedMessage id="app.register.confirm.email_confirmed" defaultMessage="Email address approved" />
          </div>
          <div className="col-span-6 flex justify-center items-center mt-4">
            <span className='mr-4'><FormattedMessage id="app.general.redirecting" defaultMessage="Redirecting" /></span><ThreeDots
              height="20"
              width="20"
              radius="4"
              color="#2f4d44"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </>
      }

      {(!loading && isExpired) &&
        <>
          <div className="col-span-6 flex justify-center items-center mt-36">
            <FormattedMessage id="app.register.confirm.email_error" defaultMessage="Token expired, email already verified" />
          </div>
          <div className="col-span-6 flex justify-center items-center mt-4">
            <Link className='bg-gray-700 px-5 py-3 text-sm font-medium tracking-wider text-neutral-50'
              to={'/app/login'} ><FormattedMessage id="app.header.login" defaultMessage="Login" />
            </Link>
          </div>
        </>
      }
    </div>
  )
}

export default ConfirmEmail
